import React, { useState, useEffect, useRef } from "react";
import { Steps, Spin } from "antd";
import PropTypes from "prop-types";
import { getRequest } from "../../../axios";

const parseGeneralStageResponse = (apiResponse, record) => {
  const payload = apiResponse?.data;
  let fetchedData = [];

  if (record?.bid_rfq_by_vendor !== false) {
    if (payload?.results?.success) {
      fetchedData = payload?.results?.data?.[0]?.stage_response || [];
    }
  } else if (payload?.success) {
    fetchedData = payload?.data || [];
  } else if (payload?.results?.data?.[0]?.stage_response) {
    fetchedData = payload.results.data[0].stage_response;
  } else if (Array.isArray(payload?.data)) {
    fetchedData = payload.data[0]?.stage_response || payload.data;
  }

  return Array.isArray(fetchedData) ? fetchedData : [];
};

const GeneralVendorDotStatus = ({
  rfqNumber,
  VendorID,
  generalRfqId,
  setDotLoaded,
  record,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [res, setRes] = useState([]);
  const [loading, setLoading] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (!VendorID || !generalRfqId) return;

    const fetchStageStatus = async () => {
      setLoading(true);
      try {
        const apiResponse = await getRequest("general-bid-rfq-po-stage/", {
          vendor_id: VendorID,
          general_rfq_id: generalRfqId,
        });

        const fetchedData = parseGeneralStageResponse(apiResponse, record);
        setRes(fetchedData);
        setDotLoaded(true);

        const lastFinishedIndex = fetchedData
          .map((item) => item.title)
          .lastIndexOf("Finished");
        setCurrentStep(lastFinishedIndex === 0 ? lastFinishedIndex : 0);

        setTimeout(() => {
          if (scrollContainerRef.current) {
            const stepElements =
              scrollContainerRef.current.querySelectorAll(".ant-steps-item");
            if (stepElements[lastFinishedIndex]) {
              stepElements[lastFinishedIndex].scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }
        }, 200);

        const nextWaitingIndex = fetchedData
          .slice(lastFinishedIndex + 1)
          .findIndex((item) => item.title === "Waiting");

        if (nextWaitingIndex !== -1) {
          setCurrentStep(lastFinishedIndex + 1 + nextWaitingIndex);
        } else {
          setCurrentStep(lastFinishedIndex);
        }
      } catch (error) {
        console.error("Error fetching general RFQ stage data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStageStatus();
  }, [generalRfqId, VendorID, rfqNumber, record, setDotLoaded]);

  return (
    <div
      ref={scrollContainerRef}
      className="gridtimelinepopup"
      style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}
    >
      {loading ? (
        <Spin
          tip="Loading..."
          style={{ display: "block", margin: "20px auto" }}
        />
      ) : (
        <Steps
          progressDot
          current={currentStep}
          direction="vertical"
          items={res.map((item, index) => ({
            title: (
              <span
                style={{
                  fontWeight: index === currentStep + 0 ? "650" : "normal",
                  fontSize: index === currentStep + 0 ? "16px" : "14px",
                  color: index === currentStep + 0 ? "#555555" : "inherit",
                }}
              >
                {item.title}
              </span>
            ),
            description: (
              <span
                style={{
                  fontWeight: index === currentStep + 0 ? "650" : "normal",
                  fontSize: index === currentStep + 0 ? "16px" : "14px",
                  color: index === currentStep + 0 ? "#555555" : "inherit",
                }}
              >
                {item.title === "In Progress" ? (
                  <h6>{item.description}</h6>
                ) : (
                  item.description
                )}
              </span>
            ),
          }))}
        />
      )}
    </div>
  );
};

GeneralVendorDotStatus.propTypes = {
  rfqNumber: PropTypes.string,
  VendorID: PropTypes.number,
  generalRfqId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setDotLoaded: PropTypes.func,
  record: PropTypes.object,
};

export default React.memo(GeneralVendorDotStatus);
